import styled from "styled-components";
export const CheckBoxSection = styled.div`
  /* Customize the label (the checkbox-container) */
  display: inline-flex;
  &.responsive {
    .checkbox-container {
      padding-left: clamp(22px, 1.302vw, 25px);
      margin: 5px 0 0 0;
      font-size: clamp(12px, 0.833vw, 16px);
      /* line-height: clamp(12px, 0.833vw, 16px); */
      line-height: 16px;
    }

    /* Create a custom checkbox */
    .checkbox-container .checkmark {
      height: clamp(15px, 0.885vw, 17px);
      width: clamp(15px, 0.885vw, 17px);
      /* border: 2px solid rgba(0, 0, 0, 0.6); */
    }

    .checkmark:after {
      /* left: clamp(2px, 0.208vw, 4px); */
      left: 4px;
      top: min(0.052vw, 1px);
      width: clamp(4px, 0.26vw, 5px);
      height: clamp(5px, 0.469vw, 9px);
      border-width: 0 2px 2px 0;
    }
  }
  .checkbox-container {
    display: block;
    position: relative;
    padding-left: 25px;
    margin: 5px 0 0 0;
    cursor: pointer;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.005em;
    color: #000000;
    user-select: none;
    font-family: "latosemibold";
    /* margin-bottom: 20px; */
  }

  /* Hide the browser's default checkbox */
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkbox-container .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 3px;
    height: 17px;
    width: 17px;
    background-color: #f7f9fa;
    /* border: 2px solid rgba(0, 0, 0, 0.6); */
    border: 2px solid #61ae24;
    border-radius: 2px;
  }

  /* On mouse-over, add a grey background color */
  .checkbox-container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkmark {
    /* background-color: #0a5587; */
    border-color: #61ae24;
    background: linear-gradient(180deg, #61b01f 0, #27911b);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkmark:after {
    left: 4px;
    top: 1px;
    width: 5px;
    height: 9px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;
